import * as amplitude from '@amplitude/analytics-browser'
import {
  BrowserClient,
  BrowserConfig,
  EnrichmentPlugin,
  Event,
} from '@amplitude/analytics-types'
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser'

export type AmplitudeClient = BrowserClient

export interface AmplitudeConfig {
  apiKey: string
  application: string
  brand: string
  environment: string
}

export const createAmplitudeInstance = (config: AmplitudeConfig): AmplitudeClient => {
  const instance = amplitude.createInstance()
  const amplitudeConfig = {
    identityStorage: 'localStorage',
    serverZone: 'EU',
    autocapture: true,
  } as BrowserConfig
  instance.add(sessionReplayPlugin({ sampleRate: 0.1 }))
  instance.add(new Amplitude(config.application, config.brand, config.environment))
  instance.init(config.apiKey, amplitudeConfig)
  return instance
}

class Amplitude implements EnrichmentPlugin {
  name = 'wrisk-properties-plugin'
  brand: string
  environment: string
  application: string

  constructor(application: string, brand: string, environment: string) {
    this.brand = brand
    this.environment = environment
    this.application = application
  }

  async setup(_config: BrowserConfig): Promise<void> {
    return undefined
  }

  async execute(event: Event): Promise<Event | null> {
    const customEventProperties = {
      Brand: this.brand,
      Application: this.application,
      Environment: this.environment,
    }

    event.event_properties = {
      ...event.event_properties,
      ...customEventProperties,
    }

    return event
  }
}
